var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFootballLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 48,
    fill: "#CCC",
    stroke: "#333",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 25 L65.45 35.73 L59.09 54.27 L40.91 54.27 L34.55 35.73 Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 25 L65.45 35.73 L75 25 L65.45 4.27 L50 -5 L34.55 4.27 Z",
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.45 35.73 L85 35 L85 65 L65 75 L50 65 L50 45 Z",
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.09 54.27 L69.09 60 L80.45 54.27 L75 75 L50 85 L40.91 54.27 Z",
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.91 54.27 L50 85 L34.55 75 L25 65 L19.55 45.73 L34.55 35.73 Z",
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.55 35.73 L15 35 L15 65 L35 75 L50 65 L50 45 Z",
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.55 35.73 L15 25 L34.55 4.27 L50 25 Z",
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootballLogo);
export default __webpack_public_path__ + "static/media/football-logo.8eddffc52c58d9323ebd87a2498711b0.svg";
export { ForwardRef as ReactComponent };